import Confetti from "react-confetti";
import type { ScreenType } from "./types";


/*
 * Static chrome of the City Hall screen: the layers behind and in front of
 * whichever screen is currently mounted. Moved out of CityHallScreen verbatim;
 * none of these hold state, and their sibling order in the tree is unchanged.
 */

/** Confetti overlay, scrollbar-hiding style and the two background layers. */
export function CityHallBackdrop({ showConfetti }: { showConfetti: boolean }) {
  return (
    <>
      {showConfetti && (
        <div className="fixed inset-0 z-[10003] pointer-events-none">
          <Confetti width={window.innerWidth} height={window.innerHeight} recycle={false} numberOfPieces={200} gravity={0.3} />
        </div>
      )}
      <style>{`
        .cityhall-scrollable::-webkit-scrollbar {
          display: none;
        }
        .cityhall-scrollable {
          -ms-overflow-style: none;
          scrollbar-width: none;
        }
      `}</style>
      <div className="absolute inset-0 z-0 bg-[image:var(--gradient-city-hall-background)]" />
      {/* Background image */}
      <div className="absolute inset-0 z-0 bg-[url('/game-assets/nscene-backgrounds/background-sea.webp')] bg-cover bg-center bg-no-repeat" />
    </>
  );
}

/** Round close button, shown on the main screen only. */
export function CityHallCloseButton({ handleClose }: { handleClose: () => void }) {
  return (
      <button
        onClick={handleClose}
        className="absolute top-[5px] right-[5px] z-[10005] flex h-[40px] w-[40px] cursor-pointer items-center justify-center rounded-[50%] border-0 border-none bg-transparent text-[24px] text-white [text-shadow:-1px_-1px_0_var(--color-black),1px_-1px_0_var(--color-black),-1px_1px_0_var(--color-black),1px_1px_0_var(--color-black)]"
        aria-label="Close"
      >
        ×
      </button>
  );
}

/** Darkening gradients and the elder character standing in the foreground. */
export function CityHallForeground({ currentScreen }: { currentScreen: ScreenType }) {
  // Full-screen Talk-to-Mayor overlay replaces this chrome; keep elder/gradients
  // out so they cannot paint over the chat (their z-index outranks the overlay).
  if (currentScreen === "talk_to_mayor") return null;

  return (
    <>
      {/* Bottom darkening gradient */}
      <div
        className="absolute right-0 bottom-0 left-0 z-[10003] h-[200px] pointer-events-none"
        style={{
          background: currentScreen === "main" 
            ? "linear-gradient(180deg, var(--color-black-alpha-0) 0%, var(--color-black-alpha-60) 100%)"
            : "linear-gradient(180deg, var(--color-black-alpha-0) 0%, var(--color-black-alpha-90) 100%)",
        }}
      />

      {/* Top darkening gradient (only for secondary screens) */}
      {currentScreen !== "main" && (
        <div className="absolute top-0 right-0 left-0 z-[10003] h-[200px] pointer-events-none bg-[linear-gradient(0deg,var(--color-black-alpha-0)_0%,var(--color-black-alpha-90)_100%)]" />
      )}

      {/* Elder character */}
      {currentScreen !== "vote_list" && currentScreen !== "register" && currentScreen !== "mayor_info" && (
      <div
        className="absolute bottom-0 left-0 flex h-[355px] w-[298px] items-end pointer-events-none"
      >
        <img
          src="/game-assets/nscene-characters/character-elder.png"
          alt="Elder"
          className="h-full w-full object-contain object-left-bottom"
        />
      </div>
      )}
    </>
  );
}
